var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlashlightCuate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-18"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 240.74,
    y: 62.53,
    width: 81.53,
    height: 58.85,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.43,
    y: 70.23,
    width: 66.14,
    height: 43.47,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.43,
    y: 70.23,
    width: 66.14,
    height: 43.47,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.43,
    y: 70.23,
    width: 66.14,
    height: 43.47,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "286.43 70.23 248.44 108.22 248.44 94.57 272.78 70.23 286.43 70.23",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "314.58 85.98 314.58 90.47 291.36 113.69 286.85 113.69 314.58 85.98",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "262.27 70.23 248.44 84.07 248.44 82.56 260.77 70.23 262.27 70.23",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "314.58 100.11 314.58 101.62 302.5 113.69 300.99 113.69 314.58 100.11",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "314.21 70.23 270.74 113.69 269.24 113.69 312.71 70.23 314.21 70.23",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 112.57,
    y: 62.53,
    width: 81.53,
    height: 58.85,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.26,
    y: 70.23,
    width: 66.14,
    height: 43.47,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.26,
    y: 70.23,
    width: 66.14,
    height: 43.47,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "186.41 75.81 186.41 89.46 162.17 113.69 148.52 113.69 186.41 75.81",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "151.18 70.23 120.26 101.15 120.26 96.64 146.69 70.23 151.18 70.23",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.22 70.23 120.26 82.18 120.26 80.69 130.72 70.23 132.22 70.23",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.41 98.24 186.41 99.74 172.45 113.69 170.95 113.69 186.41 98.24",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "160.6 70.23 120.26 110.56 120.26 109.06 159.1 70.23 160.6 70.23",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "41.4 362.04 227.27 362.04 231.14 285.78 37.54 285.78 41.4 362.04",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.46,320.69h-77.7l-1.46-26.48h80.87Zm-76.81-.94h75.94l1.57-24.6H140.29Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217,351.15H143.8l-1.19-23.9h75.91Zm-72.34-.94h71.46l1.38-22H143.6Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.09,310.32H174l-.83-6.38h14.71Zm-12.23-.94h11.41l.58-4.51H174.28Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.09,342.39H174l-.83-6.38h14.71Zm-12.23-.94h11.41l.58-4.51H174.28Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.06,320.69H49.35L47.9,294.21h80.86Zm-76.82-.94h75.94l1.58-24.6H48.89Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.63,351.15H52.4l-1.19-23.9h75.91Zm-72.34-.94h71.46l1.37-22H52.19Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.69,310.32H82.63l-.82-6.38h14.7Zm-12.23-.94h11.4l.59-4.51H82.88Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.69,342.39H82.63L81.81,336h14.7Zm-12.23-.94h11.4l.59-4.51H82.88Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "58.07 362.04 56.91 370.35 54.56 387.05 49.97 387.05 49.97 362.04 58.07 362.04",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "58.07 362.04 56.91 370.35 49.97 370.35 49.97 362.04 58.07 362.04",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.61 362.04 211.77 370.35 214.12 387.05 218.71 387.05 218.71 362.04 210.61 362.04",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.61 362.04 211.77 370.35 218.71 370.35 218.71 362.04 210.61 362.04",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.19,205.74a67,67,0,0,1,1.59-11.19,24.78,24.78,0,0,1,4-9.44,12,12,0,0,1,7.84-4.88,11,11,0,0,1,8.24,2.93,39.82,39.82,0,0,1,7.07,8.64,106.23,106.23,0,0,1,6.1,10.68c.06.12-.12.22-.18.1a68,68,0,0,0-5.46-8.94,57.26,57.26,0,0,0-6.29-7.61c-2.1-2.05-4.78-4-7.83-4.07a9.62,9.62,0,0,0-7.67,3.95A23.64,23.64,0,0,0,83.73,195a67.22,67.22,0,0,0-1.57,10.65c-.6,7.37-.77,14.79-.93,22.18-.1,4.18-.15,8.36-.19,12.54q0,3.18-.05,6.36a39.2,39.2,0,0,1-.25,6.13c-.07.41-.74.37-.81,0a36.31,36.31,0,0,1-.28-5.81q0-3-.07-6c0-3.91-.06-7.81,0-11.72C79.56,221.42,79.65,213.56,80.19,205.74Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.71,200.18c.4-2.08,1.1-4.8,2.29-6.41,2.13-2.9,4.43-1.64,2.3,1.57a19.19,19.19,0,0,0-3,7.92s3.59,5.12,7.91,7.65a34.18,34.18,0,0,1-.35-7.93c.83-6.32,4.66-6,3.71-.94a43.94,43.94,0,0,0-.87,10.17,21.53,21.53,0,0,0,4.63,2.26c-.25-.73-.51-1.61-.8-2.68-1.54-5.67,2.24-7.44,2.36-4.25a44.82,44.82,0,0,0,1.48,8.05c2.07.7,3.79,1.17,4.84,1.54a17.71,17.71,0,0,1,7.1,4.85,22.27,22.27,0,0,0,4.84-6.26c-1.33-1.13-3.42-2.83-6.32-4.87-5.44-3.84-3.55-8.69.77-5.68,3.11,2.18,5.53,6.21,6.62,8.28a33.79,33.79,0,0,0,2.47-11.33c-4.28-4-14.84-9.6-11.66-9.6,2.87,0,9.28,4.2,11.64,5.83a31.4,31.4,0,0,0-.37-3.3c-4-2.63-17.1-6.74-15-7.92,2.29-1.29,11.41,2.93,14.17,4.27a16.69,16.69,0,0,0-2.42-5c-5.56-7.44-15.59-10-20-8.59-3.1,1-2.19,8.86-2.86,8.59C91.8,181.39,86.14,184.93,90.71,200.18Zm30.49-.86c.88-1.07,5,2.07,3.78,3.78S120.06,200.69,121.2,199.32Zm-21.33-6.7c1.08.68-.51,4.65-2.17,3.45C96.3,195.05,98.79,191.93,99.87,192.62Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.5,193.84c.56-1.11,1.15-2.22,1.79-3.28a19.2,19.2,0,0,1,2-3l-.53-.66c-.07-.08.06-.21.13-.12l.61.72a.28.28,0,0,1,.09.1c.77.93,1.49,1.87,2.18,2.84a32.39,32.39,0,0,1,3.61,1c1.22.41,2.43.83,3.62,1.33.12,0,.06.26-.06.2-1.18-.52-2.37-1-3.59-1.43s-2.32-.69-3.49-1c.38.54.75,1.08,1.11,1.63a42.16,42.16,0,0,1,6.39,2.6c2.16,1,4.23,2.22,6.3,3.41a.11.11,0,0,1-.11.18,68.75,68.75,0,0,0-6.27-3.24c-2-.94-4.07-1.71-6.09-2.6,5.08,7.92,8.13,17.07,12.2,25.54.06.12-.13.22-.18.1-1.25-3-2.68-5.87-4-8.79-1.22-2.62-2.4-5.25-3.62-7.88-.36-.76-.72-1.53-1.1-2.29.23,4.23.14,8.54.83,12.72a.11.11,0,1,1-.21,0c-.29-4.52-1.09-9-1.06-13.52,0,0,0,0,0-.06-.86-1.73-1.78-3.44-2.77-5.1-1.69,4-3.45,8-4.24,12.24,0,.13-.24.07-.2-.06,1.14-4.27,2.2-8.53,4.26-12.48a48.27,48.27,0,0,0-3.58-5.15c-.56,1-1.29,2-1.93,3s-1.24,2-1.82,3a42.87,42.87,0,0,0-3.18,6.71c0,.13-.25.06-.2-.06C99.41,198.29,100.39,196,101.5,193.84Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.47,203.47c3.26-3.26,7-7.55,12.08-7.55,4.87,0,8.44,3.93,10.5,8,2.15,4.23,2.92,9,3.53,13.66a165.08,165.08,0,0,1,1.28,16.79c.09,3.11.08,6.23,0,9.35a61,61,0,0,1-.71,9.44c-.09.5-.9.52-.93,0-.15-2.62,0-5.26,0-7.88s0-5.18-.12-7.76c-.19-5.23-.57-10.45-1.18-15.65-.54-4.54-1-9.21-2.32-13.59-1.23-4-3.53-8.48-7.54-10.22-5.47-2.37-10.81,2-14.39,5.62C61.54,203.7,61.38,203.57,61.47,203.47Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.85,210.78h0c0,.67.06,1.33.11,2a11.76,11.76,0,0,1,5.34-2.22c4.62-.49,4.33,3,1.24,3.18A17.59,17.59,0,0,0,45.19,215c.75,6.11,2.43,11,2.69,11.08a88.5,88.5,0,0,0,12.22-1.54c-1.15-2.45-3.77-5.71-2.44-6s2.8,2.63,3.54,5.74a58.31,58.31,0,0,0,8.88-2.44c-2-1.76-5.17-4-4-4.89s3.69,2.15,5.19,4.4a18,18,0,0,0,3.84-2.15c-2.74-4-9.42-4.84-8.55-7.75s7.12,1.12,9.93,6.51c3.3-3.41,4.26-8.25,3.91-12.38-2.87-.34-8.39.27-8-1.79s4.39-1.67,7.66-.47a11.49,11.49,0,0,0-1.92-4.54c-3-3.89-12.26,1-12.26,1s1-9.28-2.53-10.88c-2-.92-5.61-.91-9.21,1.2,2,.17,4.46.81,5.43,2.2,1.26,1.79-.72,2.76-2,1.94-.89-.59-2.54-2.43-5.52-2.67a18,18,0,0,0-3.33,3.69c-.34.48-.66,1-1,1.54a12.67,12.67,0,0,1,10.81.19c4,2,1.77,6.15-1.68,4.53s-6.72-3.2-10.37-2.29a25.84,25.84,0,0,0-1.76,10.35,18.2,18.2,0,0,1,5.93-2.84c4-1.05,5.19,1.33.81,1.77A17.5,17.5,0,0,0,44.85,210.78Zm4.84-6.39c-.28-1.29,2.55-1.66,3-.62S50,205.68,49.69,204.39Zm24.14,7.14c.27-.71,2.16.09,2,1C75.58,213.67,73.58,212.23,73.83,211.53ZM60.5,216.05c1.38-.55,3.53,2.87,2,3.66S59.38,216.5,60.5,216.05Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.42,225.37c2.07-3.47,4.12-7,6.3-10.36q1.52-2.38,3.18-4.66l-.5-.12-.82-.16c-.64-.11-1.28-.2-1.93-.27s-1.21-.09-1.82-.1a9,9,0,0,0-1.94.1c-.08,0-.09-.1,0-.1.65,0,1.31-.06,2-.07s1.26,0,1.89.05a17.69,17.69,0,0,1,1.77.18l1,.17c.19,0,.4.06.59.12,1.12-1.54,2.28-3.06,3.49-4.54A41.42,41.42,0,0,0,50.18,202c-.07,0,0-.12,0-.1a38.32,38.32,0,0,1,11.52,3.49c.66-.81,1.33-1.63,2-2.43s1.55-1.79,2.23-2.74c0-.07.14,0,.09.06a37.36,37.36,0,0,0-2.64,3.22h0a40.65,40.65,0,0,1,4.22,3.39q2.07,1.85,4,3.79c0,.05,0,.12-.07.08-1.3-1.29-2.64-2.52-4-3.68s-2.88-2.23-4.29-3.39a0,0,0,0,0,0,0l-1,1.27c-.17.21-.33.43-.49.64a.08.08,0,0,1,0,0c-.53.71-1.07,1.41-1.61,2.12a16.66,16.66,0,0,1,1.61,2.89c.46,1,.87,2,1.24,3a44,44,0,0,1,1.73,6.49c0,.07-.09.1-.1,0a38.48,38.48,0,0,0-1.89-6.37c-.4-1.06-.86-2.09-1.34-3.12s-1-1.84-1.35-2.79c-.47.62-.93,1.24-1.38,1.87-.14.18-.26.36-.39.55a.06.06,0,0,1,0,.09h0c-1.43,2-2.78,4-4.1,6.09a1.63,1.63,0,0,1,.18.45l.24.75c.15.51.26,1,.36,1.55s.16,1,.21,1.47a13.28,13.28,0,0,0,.12,1.68.05.05,0,1,1-.1,0,5.48,5.48,0,0,0-.12-1.56,14.54,14.54,0,0,0-.3-1.6c-.11-.47-.24-1-.38-1.42-.07-.23-.14-.46-.22-.7s-.11-.25-.15-.38c-.62,1-1.23,1.94-1.83,2.92l-3.57,5.82C48.51,225.55,48.36,225.47,48.42,225.37Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4,252c.06-2,.37-3.95.58-5.9s.43-3.93.64-5.89a90.27,90.27,0,0,1,1.52-11.37,16.48,16.48,0,0,1,4.63-8.49,7.56,7.56,0,0,1,4.53-2.17,7.84,7.84,0,0,1,4.81,1.49,16.58,16.58,0,0,1,4,4.26,41.56,41.56,0,0,1,3.16,5.13c0,.07-.07.11-.11,0a26.29,26.29,0,0,0-6.83-7.65,8.07,8.07,0,0,0-4.3-1.79,5.86,5.86,0,0,0-4.18,1.66,15.72,15.72,0,0,0-4.41,7.8,78.93,78.93,0,0,0-1.7,10.5q-.42,3.12-.82,6.24c-.27,2.07-.45,4.19-.88,6.23A.35.35,0,0,1,80.4,252Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.07,236.73a10.53,10.53,0,0,0,2.14,2.19c-.33-1.92-.72-5.33.25-7.14,1.5-2.82,3.28-1.41,2.39,1a20,20,0,0,0-1.45,6.94,30.2,30.2,0,0,0,6.53,3.08,10.83,10.83,0,0,1-.22-3.36c.3-3,2.61-3,2,.18a19.61,19.61,0,0,0-.32,3.68,67.39,67.39,0,0,0,10.18,2.29,29.73,29.73,0,0,0,4.21-7.49c-2.45-.62-7.42-.76-7.31-2.51.14-2.36,5-.54,7.76,1.17a18.75,18.75,0,0,0,.85-6.35,32.08,32.08,0,0,0-6.76-1.12c-5-.43-4.8-3.29-1.14-3.23,2.7.05,6.11,1.7,7.73,2.56-1-6.86-6.29-11.26-10.49-11.43-7.06-.29-4.52,8.5-4.52,8.5s-4.78-3.37-9.3-3.28S85.24,230,90.07,236.73ZM108.93,224c-.16-1,3-1.22,3.15.05S109.08,225,108.93,224ZM114,234.34c-.06-.65,1.3-.76,1.61.06C115.8,234.93,114.05,235,114,234.34Zm-16.95.6c1.07.15,1.67,4-.16,3.88C95.48,238.76,96.14,234.81,97,234.94Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.51,239.17c.18-.48.34-1,.49-1.44-.14.49-.26,1-.35,1.47C98.63,239.3,98.48,239.26,98.51,239.17Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.38,233.05c.33-1,.7-1.94,1.08-2.89.2-.52.41-1,.64-1.52a5.83,5.83,0,0,1,.62-1.28,11.4,11.4,0,0,1-.57-1.23,0,0,0,0,1,.07,0,14.85,14.85,0,0,1,1.37,2.13l.58,1a9.81,9.81,0,0,1,1.19.19c.42.07.84.16,1.26.25l1.26.3c.41.1.83.23,1.25.3.1,0,.06.17,0,.13a7.63,7.63,0,0,0-1.33-.34c-.4-.09-.81-.16-1.22-.22s-.82-.11-1.23-.15l-.93-.08c.16.3.34.59.5.89l.08.14a3.83,3.83,0,0,1,1,.12l1.09.22c.74.16,1.47.33,2.2.54,1.53.42,3,.91,4.54,1.4.09,0,0,.16,0,.13a45.33,45.33,0,0,0-4.56-1.27L107,231.3l-1.09-.23a8.58,8.58,0,0,1-.85-.18q1.17,2.15,2.19,4.38c1.46,3.24,2.69,6.57,4,9.9,0,.08-.1.13-.13.05a90.1,90.1,0,0,0-4.2-9.68c-.29-.57-.58-1.14-.86-1.72a3.59,3.59,0,0,1-.08.35c-.07.4-.14.79-.2,1.18q-.21,1.18-.39,2.37a28,28,0,0,0-.57,4.9.07.07,0,1,1-.13,0c.12-.78.12-1.59.17-2.39s.11-1.65.21-2.47.19-1.58.32-2.37l.21-1.18a2.48,2.48,0,0,1,.22-.86c-.41-.83-.82-1.66-1.24-2.48s-.79-1.55-1.19-2.32c-.17-.33-.36-.66-.54-1a8.65,8.65,0,0,1-.47,1.19l-.54,1.33c-.41,1-.78,2-1.16,3-.53,1.41-1.12,2.86-1.56,4.33C99.53,235.94,99.89,234.48,100.38,233.05Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99,237.73a3.37,3.37,0,0,1,.1-.34C99.06,237.5,99,237.62,99,237.73Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "68.6 248.17 69.09 258.68 70.37 285.77 98.32 285.77 99.59 258.68 100.09 248.17 68.6 248.17",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "68.6 248.17 69.09 258.68 99.59 258.68 100.09 248.17 68.6 248.17",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.61,
    y: 243.93,
    width: 35.47,
    height: 8.5,
    transform: "translate(168.69 496.35) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-18"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 192.25,
    cy: 436.36,
    rx: 156.2,
    ry: 20.13,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.07,387.05c25.52-.09,51.05-.28,76.57-.28l76.58-.12,76.57-.09,76.58.12h.06l62.77,11.26,62.73,11.41L403.1,398.46l-62.8-11h.07l-76.58.11-76.57-.09-76.58-.11C85.12,387.32,59.59,387.14,34.07,387.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339.59 387.05 339.35 344.27 339.26 301.5 339.09 215.95 339.26 130.41 339.35 87.64 339.59 44.86 339.83 87.64 339.92 130.41 340.09 215.95 339.92 301.5 339.83 344.27 339.59 387.05",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Boxes--inject-18"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 252.71,
    y: 335.22,
    width: 57.3,
    height: 63.45,
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 335.22,
    width: 29.59,
    height: 63.45,
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 335.22,
    width: 29.59,
    height: 63.45,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "286.22 348.93 285.01 348.93 284.09 348.93 283.57 347.88 282.85 348.93 281.86 346.76 280.92 348.93 278.24 348.93 277.01 348.93 276.57 347.48 276.15 348.93 275.36 348.93 275.36 335.22 286.22 335.22 286.22 348.93",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.55,394.3q-3.29-6.76-6.51-13.58l-6.42-13.64-6.34-13.71q-3.15-6.87-6.24-13.78,3.29,6.77,6.52,13.58L325,366.82l6.34,13.71Q334.46,387.39,337.55,394.3Z",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.55,339.6q-3.09,6.9-6.24,13.77L325,367.08l-6.42,13.64q-3.23,6.82-6.51,13.58,3.09-6.9,6.24-13.77l6.34-13.71L331,353.17Q334.27,346.36,337.55,339.6Z",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.78,
    y: 271.87,
    width: 57.3,
    height: 63.45,
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.07,
    y: 271.88,
    width: 29.59,
    height: 63.45,
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.07,
    y: 271.88,
    width: 29.59,
    height: 63.45,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "276.29 285.58 275.08 285.58 274.17 285.58 273.65 284.53 272.92 285.58 271.93 283.41 270.99 285.58 268.31 285.58 267.08 285.58 266.64 284.13 266.23 285.58 265.43 285.58 265.43 271.87 276.29 271.87 276.29 285.58",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.62,331q-3.28-6.78-6.51-13.58l-6.42-13.65L308.35,290q-3.15-6.86-6.23-13.77,3.28,6.76,6.51,13.57l6.42,13.65,6.33,13.71Q324.53,324,327.62,331Z",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.62,276.25q-3.09,6.9-6.24,13.77l-6.33,13.71-6.42,13.65q-3.22,6.81-6.52,13.57,3.09-6.9,6.24-13.77l6.34-13.71,6.42-13.64Q324.33,283,327.62,276.25Z",
    style: {
      fill: "#3DD064"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.1,154.82c-12.83,11.07-31.55,30.75-30.61,37,.84,5.6,5.92,25.72,13.15,35.54,1.87,2.54,24.93-9,22.7-11.5-4.67-5.31-10.82-18.82-11.81-22.54C123.65,190,136,169.6,141,158.48,147.16,145,136.22,150.41,131.1,154.82Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.31,211.43,121,218.72l0,0-.25.16-8.61,5.53a18.93,18.93,0,0,0,.82,2.36h0a87.39,87.39,0,0,0,9.47,17c2.39,3.22,10.22,11.72,12.83,10.07s.54-4.33.54-4.33,3.85,3.1,6.32,1.21c2-1.56.14-4.57-.6-5.62l-.13-.16v0l-.14-.18s4.19,2.89,6.51.83c2.08-1.84-.94-4.86-1.6-5.48l-.08-.08.07.05c.63.45,3.71,2.47,4.79.22,1.45-3-6-7.45-8.42-11.14-.12-.18-.68-1.14-1.48-2.53l-3.37-5.92Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.69,228.78a35.49,35.49,0,0,0,2.43,5.21,14.33,14.33,0,0,0,7.67,6.22c.17.07.27,0,.29-.06a0,0,0,0,0,0,0c0-.06,0-.12-.14-.18a21.87,21.87,0,0,1-7-5.94,36.35,36.35,0,0,1-3.1-5.29A.09.09,0,1,0,135.69,228.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.47,233c2.85,5.8,4.77,9.06,10.63,12.24.18.11.35,0,.35-.08a.23.23,0,0,0-.11-.15h0v0c-5.33-3.88-7.32-6.44-10.69-12.06C130.58,232.84,130.43,232.91,130.47,233Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.3,249.23c-4.91-4.15-7.21-6.86-9.79-12.74a.12.12,0,0,0-.22.08c2,6.26,4.89,9.66,9.87,12.79C135.5,249.58,135.61,249.49,135.3,249.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.71,220.7a7.84,7.84,0,0,0,.74.68l.23.17h0c4.4,3.13,11.66,0,11.66,0a31.13,31.13,0,0,0,2.55,4.7c1.43,2.15,3.15,4.11,4.88,4.73h0a3,3,0,0,0,1.41.18,2.47,2.47,0,0,0,.74-.2.11.11,0,0,0,.07,0c1.28-.65.87-4-.15-7.6-1.12-4-3-8.26-4.18-9.69-1.54-1.83-10.11-6.72-10.11-6.72S118.52,216.22,122.71,220.7Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.81,231.11c-4.35-1-6.19-6.11-8.06-9.67a.37.37,0,0,0-.6-.1c-3.64,1.27-9.15,2-12.45-.39-.09-.07-.21.06-.12.14,3.19,3,8.66,2.77,12.56,1.12,1.86,3.68,3.93,8.73,8.66,8.94C143.83,231.15,143.84,231.11,143.81,231.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.84,221.39,131.22,206s-6-10.89-6.28-13,13.94-27.69,17.14-36-1.08-9.27-9.81-3.49-31.35,30.13-32.3,36.49S108.84,221.39,108.84,221.39Z",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.05,185.11a1.12,1.12,0,0,1-.47.35,1.06,1.06,0,0,1-1-.13,1.32,1.32,0,0,0-1.51,0,2.66,2.66,0,0,0-.75,1.18,5.44,5.44,0,0,0,.49-.47,1.19,1.19,0,0,1,.46-.36,1.06,1.06,0,0,1,1,.09,1.36,1.36,0,0,0,1.5.06,2.38,2.38,0,0,0,.77-1.18C107.37,184.79,107.22,185,107.05,185.11Zm13.69,21.43a1.18,1.18,0,0,1-.47.35,1.09,1.09,0,0,1-1-.14,1.34,1.34,0,0,0-1.51,0,2.53,2.53,0,0,0-.75,1.18c.17-.15.32-.31.49-.47a1.1,1.1,0,0,1,.46-.36,1,1,0,0,1,1,.09,1.36,1.36,0,0,0,1.51.05,2.31,2.31,0,0,0,.77-1.17A5.44,5.44,0,0,0,120.74,206.54Zm.57-40.93a1.09,1.09,0,0,1-.46.35,1.06,1.06,0,0,1-1-.13,1.39,1.39,0,0,0-1.17-.18c-.31.31-.61.63-.92.95-.06.14-.11.28-.18.41.18-.15.33-.32.49-.47a1.13,1.13,0,0,1,.46-.37,1.08,1.08,0,0,1,1,.09,1.35,1.35,0,0,0,1.5.06,2.47,2.47,0,0,0,.78-1.18C121.63,165.29,121.48,165.46,121.31,165.61Zm7.47,15.21a1,1,0,0,1-.47.35,1.06,1.06,0,0,1-1-.13,1.34,1.34,0,0,0-1.51,0,2.58,2.58,0,0,0-.76,1.19c.18-.15.33-.32.49-.47a1.32,1.32,0,0,1,.47-.37,1.06,1.06,0,0,1,1,.09,1.33,1.33,0,0,0,1.5.06,2.5,2.5,0,0,0,.78-1.17C129.09,180.5,128.94,180.67,128.78,180.82Zm11.42-20.17a2.66,2.66,0,0,0-.76,1.19c.18-.15.33-.32.49-.47a1.48,1.48,0,0,1,.36-.32c.1-.19.18-.38.26-.57A1.27,1.27,0,0,0,140.2,160.65Zm-24.28,13.11c0,.23,0,.45,0,.68a1.25,1.25,0,0,1-.07.59,1.07,1.07,0,0,1-.78.65,1.36,1.36,0,0,0-1.11,1,2.41,2.41,0,0,0,.29,1.38c0-.23,0-.45,0-.68a1.22,1.22,0,0,1,.09-.58,1.05,1.05,0,0,1,.81-.62,1.37,1.37,0,0,0,1.08-1.07A2.67,2.67,0,0,0,115.92,173.76Zm-6.65,24.08c0,.23,0,.45,0,.68a1.1,1.1,0,0,1-.07.58,1,1,0,0,1-.78.65,1.37,1.37,0,0,0-1.11,1,2.36,2.36,0,0,0,.29,1.37c0-.22,0-.45,0-.67a1.08,1.08,0,0,1,.08-.58,1.06,1.06,0,0,1,.81-.63,1.34,1.34,0,0,0,1.08-1.06A2.55,2.55,0,0,0,109.27,197.84Zm19.92-42.09-.17.14V156a1.39,1.39,0,0,1-.07.59,1.07,1.07,0,0,1-.78.65,1.35,1.35,0,0,0-1.11,1,2.41,2.41,0,0,0,.29,1.38c0-.23,0-.45,0-.68a1.11,1.11,0,0,1,.09-.58,1,1,0,0,1,.81-.62,1.37,1.37,0,0,0,1.08-1.07A1.88,1.88,0,0,0,129.19,155.75Zm10.86-5.95A7.79,7.79,0,0,0,139,150a.75.75,0,0,0,.25.09,2.39,2.39,0,0,0,1.37-.29A5.42,5.42,0,0,0,140.05,149.8Zm-28.73,66.53a1.1,1.1,0,0,1-.58-.08,1.08,1.08,0,0,1-.63-.82,1.33,1.33,0,0,0-1.06-1.07,2.64,2.64,0,0,0-1.37.3c.23,0,.45,0,.68,0a1.08,1.08,0,0,1,.58.07,1,1,0,0,1,.66.78,1.35,1.35,0,0,0,1,1.1,2.4,2.4,0,0,0,1.38-.28C111.77,216.33,111.55,216.34,111.32,216.33Zm6.7-24a1.08,1.08,0,0,1-.58-.08,1.06,1.06,0,0,1-.63-.82,1.33,1.33,0,0,0-1.06-1.07,2.64,2.64,0,0,0-1.37.3c.23,0,.45,0,.68,0a1.1,1.1,0,0,1,.58.07,1,1,0,0,1,.65.78,1.36,1.36,0,0,0,1,1.1,2.35,2.35,0,0,0,1.37-.28C118.47,192.28,118.24,192.3,118,192.29Zm15.23-21.06a1.1,1.1,0,0,1-.58-.08,1.08,1.08,0,0,1-.63-.82,1.33,1.33,0,0,0-1.06-1.07,2.64,2.64,0,0,0-1.37.3c.23,0,.45,0,.68,0a1.14,1.14,0,0,1,.59.07,1,1,0,0,1,.65.78,1.35,1.35,0,0,0,1,1.1,2.33,2.33,0,0,0,1.38-.28C133.7,171.23,133.48,171.24,133.25,171.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.55,202.53c-3.43,1.9-6.73,4.07-10,6.3-1.58,1.09-3.15,2.2-4.69,3.36s-3.13,2.49-4.7,3.73a.07.07,0,0,0,.08.12c1.64-1.14,3.35-2.18,5-3.31s3.16-2.18,4.74-3.28c3.23-2.23,6.47-4.45,9.6-6.81A.07.07,0,0,0,127.55,202.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.74,188.76a35.71,35.71,0,0,0-2.15-4.45s-.08,0-.07,0c.58,1.55,1,3.14,1.63,4.69s1.33,3.07,1.8,4.66c0,.1.18.05.15,0C124.64,192,124.35,190.36,123.74,188.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.08,156.93c-3.2,8.36-17.39,33.95-17.14,36s6.28,13,6.28,13l-22.38,15.41s-6.49-16.57-8.41-26.19l33.17-42.61h0C141.43,147.78,145.11,149,142.08,156.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.61,356.66S51,389.86,50.93,389.88c-4.17,6.33-7.72,11.95-9.28,15l0,0a5.31,5.31,0,0,0-.82,2.26.15.15,0,0,0,0,.07c1,2.51,50.63,37.36,52.77,38s4.11-5.41,3.27-8.3S83,412.26,83,412.26l21.34-33.4Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.38,383.07s-4.43,6.79-4.45,6.81c-4.17,6.33-7.72,11.95-9.28,15l0,0a10.06,10.06,0,0,0-.82,2.26.15.15,0,0,0,0,.07c1,2.51,50.63,37.36,52.77,38s4.11-5.41,3.27-8.3S83,412.26,83,412.26l4.61-6.86Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.87,445.32c-2.19-.6-53.27-35-54.39-37.57-.43-1,4.11-9.35,10.68-17.59l32.91,22.23s13,21.5,14,24.43S96.06,445.93,93.87,445.32Z",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.51,442.78c-8.42-6-42.95-29.3-51.73-34.57-.07,0-.1,0,0,.05,8.22,6.11,42.94,29.16,51.68,34.67C94.6,443,94.69,442.91,94.51,442.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.17,415.06C81.78,412.7,77,411.23,73,412.6c-.15,0-.08.27.06.29A56.7,56.7,0,0,1,85,415.52.26.26,0,0,0,85.17,415.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.13,417.87c-3.4-2.36-8.19-3.82-12.21-2.46-.15.06-.08.28.06.29a57.33,57.33,0,0,1,11.92,2.63A.26.26,0,0,0,87.13,417.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.08,420.69c-3.4-2.36-8.19-3.83-12.21-2.46-.15,0-.07.27.06.29a56.7,56.7,0,0,1,11.92,2.63A.26.26,0,0,0,89.08,420.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91,423.5c-3.4-2.36-8.19-3.82-12.21-2.46-.15.06-.07.28.06.29A57.19,57.19,0,0,1,90.8,424,.26.26,0,0,0,91,423.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.51,388.88l33.87,24.61s42.33-69.72,43.27-86.27c1-17.81,13.68-96.47,14.55-107H103.3c-5,25.76-12.83,95.69-14.11,100.92C86.52,332.12,51.51,388.88,51.51,388.88Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.38,404.59a58.48,58.48,0,0,0-5.65-4.39c-2-1.43-4-2.83-6-4.23-4.06-2.83-8.16-5.61-12.26-8.38-2.31-1.56-4.63-3.09-7-4.51a.08.08,0,0,0-.09.13c3.82,3.09,7.87,5.89,11.88,8.73s8,5.61,12,8.34a65.76,65.76,0,0,0,7.09,4.44C89.34,404.76,89.46,404.66,89.38,404.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.42,231.54c-2,11.14-3.92,22.31-5.78,33.49S123,287.4,121.19,298.6q-1.34,8.36-2.68,16.71c-.87,5.4-1.56,10.88-2.84,16.2s-3.78,10.21-6.19,15.13-4.76,9.67-7.17,14.49c-4.85,9.69-11.2,21.46-16.62,30.84-.67,1.16-1.35,2.3-2,3.45,0,.09.08.16.14.07,6-9.07,12.58-20.81,17.61-30.46,2.49-4.78,4.9-9.6,7.3-14.43s5-9.54,6.74-14.6,2.45-10.63,3.31-16c.9-5.63,1.83-11.25,2.74-16.87,1.82-11.19,3.67-22.37,5.44-33.57s3.57-22.52,5.18-33.81c.19-1.38.39-2.77.59-4.15C132.74,231.42,132.46,231.35,132.42,231.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.91,380.67s-.18,39.63-.18,39.66c0,7.58.06,14.23.44,17.66v.06a5.28,5.28,0,0,0,.55,2.34s0,0,.05.05c2.24,1.54,62.82,3.61,64.95,3s.49-6.78-1.8-8.73-25.13-13.13-25.13-13.13l-.38-39.62Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.73,412.19v8.14c0,7.58.06,14.23.44,17.66v.06a10.48,10.48,0,0,0,.55,2.34s0,0,.05.05c2.24,1.54,62.82,3.61,64.95,3s.49-6.78-1.8-8.73-25.13-13.13-25.13-13.13l.11-8.25Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.71,443.64c-2.18.65-63.74-1.44-66-3-.87-.58-1.47-10.11-.27-20.58l39.69,1.4s22.44,11.32,24.78,13.31S210.88,443,208.71,443.64Z",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.91,441.15c-10.31-.61-52-2.07-62.2-1.88-.08,0-.08.06,0,.06,10.21.82,51.87,1.95,62.2,2C208.12,441.32,208.13,441.16,207.91,441.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.29,422.59c-4.13-.2-9,1.1-11.65,4.39-.1.13.08.27.2.22a57.07,57.07,0,0,1,11.5-4.1A.26.26,0,0,0,185.29,422.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.43,423.94c-4.12-.19-9,1.1-11.64,4.39-.11.13.07.28.2.22a57.07,57.07,0,0,1,11.5-4.1A.26.26,0,0,0,188.43,423.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.58,425.29c-4.13-.19-9,1.1-11.65,4.39-.1.13.08.28.21.22a57,57,0,0,1,11.49-4.09A.26.26,0,0,0,191.58,425.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.73,426.65c-4.13-.2-9,1.09-11.65,4.39-.11.12.08.27.2.21a57,57,0,0,1,11.5-4.09A.26.26,0,0,0,194.73,426.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.3,220.25c1.42,28.3,18,35.93,18.65,37.94,9,29.62,21.2,64.73,21.36,65.59,0,.18-3.46,96.6-3.46,96.6l43.2,1.35s-1.27-84.29-3-100.7c-2.18-20.94-26-100.78-26-100.78Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,288.34c-.31-1.19-.62-2.38-1-3.56-.68-2.39-1.38-4.79-2.11-7.17-1.45-4.72-2.92-9.47-4.69-14.08-1-2.6-2-5.21-3.14-7.75-.1-.23-.45-.14-.38.11,2.67,9.52,6.06,18.84,9.18,28.21.43,1.28.86,2.56,1.31,3.84a38.09,38.09,0,0,0,1.41,3.82c0,.07.16,0,.15,0A31.84,31.84,0,0,0,132,288.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.69,258.17c-1.82-.65-3.69-1.18-5.51-1.85s-3.71-1.42-5.52-2.23-3.5-1.64-5.22-2.52a36,36,0,0,1-5.23-3.07c-.08-.06-.19.05-.11.12.81.63,1.56,1.34,2.37,2s1.6,1.18,2.42,1.75a34.91,34.91,0,0,0,5.24,2.93,32.28,32.28,0,0,0,11.54,3.09C128.79,258.38,128.79,258.21,128.69,258.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.17,412.58A56.78,56.78,0,0,0,174,412q-3.69-.13-7.36-.22c-5-.13-9.9-.21-14.85-.27-2.79,0-5.57,0-8.36.09a.08.08,0,0,0,0,.16c4.89.48,9.81.6,14.72.77s9.73.32,14.6.39a66.67,66.67,0,0,0,8.36-.18C181.23,412.74,181.27,412.6,181.17,412.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.81,390.77q-.31-9.07-.71-18.16c-.52-12.1-1-24.21-1.6-36.31a175.92,175.92,0,0,0-1.29-17.92,168.27,168.27,0,0,0-4-17.27q-4.6-17.61-9.23-35.21c-1.54-5.87-3-11.75-4.63-17.6s-3-11.76-4.69-17.58c-.43-1.46-.83-2.92-1.27-4.37,0-.1-.16,0-.14,0,1.3,5.93,2.85,11.8,4.35,17.69s3,11.76,4.47,17.64l9,35.27c1.49,5.78,3.13,11.55,4.32,17.4A111.36,111.36,0,0,1,171.09,332q.79,18.16,1.69,36.31c.33,6.78.66,13.56,1,20.33s.67,13.57,1.22,20.33a.17.17,0,0,0,.34,0C175.32,402.88,175,396.82,174.81,390.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 398.67,
    cy: 160.6,
    rx: 49.88,
    ry: 102.6,
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.71,
    y: 238.19,
    width: 46.32,
    height: 14.87,
    transform: "translate(-83.28 92.54) rotate(-23.6)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.67 248.08 161.63 261.71 157.7 261.77 152.96 250.91 155.67 248.08",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.34 213.26 225.65 243.73 222.67 245.04 204.07 243.17 198.12 229.54 209.35 214.56 212.34 213.26",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.87,
    y: 212.52,
    width: 3.26,
    height: 33.26,
    transform: "translate(-73.54 106.23) rotate(-23.6)",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.32 231.2 198.12 229.54 204.07 243.17 202.16 244 194.32 231.2",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.1,240.24a1.54,1.54,0,1,1-2-.79A1.54,1.54,0,0,1,192.1,240.24Z",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.9,222.94,161,228.39c.86-.77-5.75-64.31-11.86-75.67-1-1.91-9.67-5.92-14.3-1.78C109.28,173.72,99.9,222.94,99.9,222.94Z",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142,217.59a1,1,0,0,1-.47.34,1.06,1.06,0,0,1-1-.13,1.34,1.34,0,0,0-1.51,0,2.61,2.61,0,0,0-.75,1.18c.18-.15.33-.31.49-.47a1.22,1.22,0,0,1,.46-.37,1.06,1.06,0,0,1,1,.1,1.34,1.34,0,0,0,1.5,0,2.31,2.31,0,0,0,.77-1.17C142.36,217.26,142.21,217.43,142,217.59Zm18.2-.78a1.37,1.37,0,0,0-.32.16,2.66,2.66,0,0,0-.75,1.18,5.44,5.44,0,0,0,.49-.47,1.1,1.1,0,0,1,.46-.36l.17,0C160.27,217.12,160.26,217,160.24,216.81ZM146.6,199.09a1.1,1.1,0,0,1-1.49.21,1.34,1.34,0,0,0-1.51,0,2.72,2.72,0,0,0-.76,1.19c.18-.15.33-.31.49-.47a1.32,1.32,0,0,1,.47-.37,1,1,0,0,1,1,.1,1.36,1.36,0,0,0,1.51,0,2.45,2.45,0,0,0,.77-1.17A5.44,5.44,0,0,0,146.6,199.09Zm-25.86,7.45a1.18,1.18,0,0,1-.47.35,1.09,1.09,0,0,1-1-.14,1.34,1.34,0,0,0-1.51,0,2.53,2.53,0,0,0-.75,1.18c.17-.15.32-.31.49-.47a1.1,1.1,0,0,1,.46-.36,1,1,0,0,1,1,.09,1.36,1.36,0,0,0,1.51.05,2.31,2.31,0,0,0,.77-1.17A5.44,5.44,0,0,0,120.74,206.54ZM100.39,222.1a1.25,1.25,0,0,1-.39.32l-.09.5.2-.11a2.43,2.43,0,0,0,.77-1.17C100.7,221.78,100.55,222,100.39,222.1Zm28.39-41.28a1,1,0,0,1-.47.35,1.06,1.06,0,0,1-1-.13,1.34,1.34,0,0,0-1.51,0,2.58,2.58,0,0,0-.76,1.19c.18-.15.33-.32.49-.47a1.32,1.32,0,0,1,.47-.37,1.06,1.06,0,0,1,1,.09,1.33,1.33,0,0,0,1.5.06,2.5,2.5,0,0,0,.78-1.17C129.09,180.5,128.94,180.67,128.78,180.82Zm14.42-20.38a1.18,1.18,0,0,1-.47.35,1.06,1.06,0,0,1-1-.13,1.34,1.34,0,0,0-1.51,0,2.66,2.66,0,0,0-.76,1.19c.18-.15.33-.32.49-.47a1.22,1.22,0,0,1,.47-.37,1.06,1.06,0,0,1,1,.09,1.36,1.36,0,0,0,1.51.06,2.45,2.45,0,0,0,.77-1.18C143.51,160.12,143.36,160.29,143.2,160.44Zm9.58,4.49a.74.74,0,0,0,0,.14,2.41,2.41,0,0,0,.29,1.38c0-.1,0-.22,0-.32v0C153,165.71,152.87,165.32,152.78,164.93Zm-2.52,59.57c0,.23,0,.45,0,.68a1.08,1.08,0,0,1-.07.58,1,1,0,0,1-.78.66,1.37,1.37,0,0,0-1,.84l.5.05a1,1,0,0,1,.65-.38,1.32,1.32,0,0,0,1.07-1.06A2.64,2.64,0,0,0,150.26,224.5Zm-24.67-7.4c0,.23,0,.46,0,.68a1.12,1.12,0,0,1-.07.59,1,1,0,0,1-.78.65,1.37,1.37,0,0,0-1.11,1,2.41,2.41,0,0,0,.29,1.38c0-.23,0-.45,0-.68a1.11,1.11,0,0,1,.08-.58,1.07,1.07,0,0,1,.81-.62,1.37,1.37,0,0,0,1.08-1.07A2.57,2.57,0,0,0,125.59,217.1Zm21.55-43.79c0,.23,0,.45,0,.68a1.25,1.25,0,0,1-.06.59,1.06,1.06,0,0,1-.79.65,1.35,1.35,0,0,0-1.1,1,2.41,2.41,0,0,0,.29,1.38c0-.23,0-.45,0-.68a1.1,1.1,0,0,1,.09-.58,1.07,1.07,0,0,1,.81-.63,1.34,1.34,0,0,0,1.08-1.06A2.64,2.64,0,0,0,147.14,173.31Zm-37.87,24.53c0,.23,0,.45,0,.68a1.1,1.1,0,0,1-.07.58,1,1,0,0,1-.78.65,1.37,1.37,0,0,0-1.11,1,2.36,2.36,0,0,0,.29,1.37c0-.22,0-.45,0-.67a1.08,1.08,0,0,1,.08-.58,1.06,1.06,0,0,1,.81-.63,1.34,1.34,0,0,0,1.08-1.06A2.55,2.55,0,0,0,109.27,197.84ZM158,200.69c0,.23,0,.46,0,.68a1.12,1.12,0,0,1-.07.59,1,1,0,0,1-.78.65,1.35,1.35,0,0,0-1.1,1,2.31,2.31,0,0,0,.28,1.37c0-.23,0-.45,0-.68a1.07,1.07,0,0,1,.9-1.2,1.34,1.34,0,0,0,1.07-1.07A2.57,2.57,0,0,0,158,200.69Zm-27.69-7.81c0,.22,0,.45,0,.67a1.12,1.12,0,0,1-.07.59,1,1,0,0,1-.78.65,1.37,1.37,0,0,0-1.11,1,2.36,2.36,0,0,0,.29,1.37c0-.23,0-.45,0-.68a1.16,1.16,0,0,1,.09-.57,1.06,1.06,0,0,1,.81-.63,1.36,1.36,0,0,0,1.08-1.06A2.64,2.64,0,0,0,130.3,192.88Zm-3-34-.22.27c.07.19.16.38.22.56,0-.23,0-.45,0-.68C127.36,158.93,127.35,158.88,127.35,158.83Zm.86-1h0a1.37,1.37,0,0,0,1.08-1.07,2.29,2.29,0,0,0,0-.25C129,156.89,128.59,157.34,128.21,157.79Zm28.65,31-.19.19a1.19,1.19,0,0,1-.47.36,1,1,0,0,1-1-.09,1.38,1.38,0,0,0-1.51-.06,2.45,2.45,0,0,0-.77,1.18c.18-.15.33-.31.49-.47a1.18,1.18,0,0,1,.47-.35,1.06,1.06,0,0,1,1,.13,1.32,1.32,0,0,0,1.51,0,1.56,1.56,0,0,0,.5-.63A2.51,2.51,0,0,0,156.86,188.77Zm-16.92-39a1.16,1.16,0,0,1-.57-.09,1.08,1.08,0,0,1-.53-.5,3.08,3.08,0,0,0-.53.08,1.32,1.32,0,0,0,.94.81,2.39,2.39,0,0,0,1.37-.29C140.39,149.79,140.17,149.8,139.94,149.8Zm2.19,39a1.08,1.08,0,0,1-.58-.09,1,1,0,0,1-.63-.81,1.34,1.34,0,0,0-1.06-1.08,2.64,2.64,0,0,0-1.37.31c.23,0,.45,0,.68,0a1.34,1.34,0,0,1,.58.07,1,1,0,0,1,.65.78,1.37,1.37,0,0,0,1,1.11,2.41,2.41,0,0,0,1.38-.29C142.58,188.76,142.35,188.77,142.13,188.77Zm-30.81,27.56a1.1,1.1,0,0,1-.58-.08,1.08,1.08,0,0,1-.63-.82,1.33,1.33,0,0,0-1.06-1.07,2.64,2.64,0,0,0-1.37.3c.23,0,.45,0,.68,0a1.08,1.08,0,0,1,.58.07,1,1,0,0,1,.66.78,1.35,1.35,0,0,0,1,1.1,2.4,2.4,0,0,0,1.38-.28C111.77,216.33,111.55,216.34,111.32,216.33ZM161,227.06a1.22,1.22,0,0,0-.51-.22,2.68,2.68,0,0,0-1.38.31c.23,0,.46,0,.68,0a1.37,1.37,0,0,1,.59.07,1.05,1.05,0,0,1,.62.67C161.05,227.69,161.05,227.4,161,227.06Zm-26.77-18.59a1.11,1.11,0,0,1-.58-.08,1.05,1.05,0,0,1-.62-.82A1.36,1.36,0,0,0,132,206.5a2.66,2.66,0,0,0-1.37.3c.23,0,.45,0,.68,0a1.14,1.14,0,0,1,.59.07,1.07,1.07,0,0,1,.65.78,1.33,1.33,0,0,0,1,1.1,2.33,2.33,0,0,0,1.38-.28C134.72,208.47,134.5,208.48,134.27,208.47ZM118,192.29a1.08,1.08,0,0,1-.58-.08,1.06,1.06,0,0,1-.63-.82,1.33,1.33,0,0,0-1.06-1.07,2.64,2.64,0,0,0-1.37.3c.23,0,.45,0,.68,0a1.1,1.1,0,0,1,.58.07,1,1,0,0,1,.65.78,1.36,1.36,0,0,0,1,1.1,2.35,2.35,0,0,0,1.37-.28C118.47,192.28,118.24,192.3,118,192.29Zm33.59,20.3a1,1,0,0,1-.58-.09,1.07,1.07,0,0,1-.63-.81,1.32,1.32,0,0,0-1.06-1.07,2.64,2.64,0,0,0-1.37.3c.23,0,.45,0,.68,0a1.2,1.2,0,0,1,.58.06,1.07,1.07,0,0,1,.66.79,1.35,1.35,0,0,0,1,1.1,2.4,2.4,0,0,0,1.38-.28C152.06,212.58,151.84,212.6,151.61,212.59Zm-18.36-41.36a1.1,1.1,0,0,1-.58-.08,1.08,1.08,0,0,1-.63-.82,1.33,1.33,0,0,0-1.06-1.07,2.64,2.64,0,0,0-1.37.3c.23,0,.45,0,.68,0a1.14,1.14,0,0,1,.59.07,1,1,0,0,1,.65.78,1.35,1.35,0,0,0,1,1.1,2.33,2.33,0,0,0,1.38-.28C133.7,171.23,133.48,171.24,133.25,171.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.51,161.11c-2.09.07-7.7-4.38-9.52-8.7-.12-.3,2.19-11.4,2.42-13.65,0-.46,13.75,4.87,13.75,4.87a36.08,36.08,0,0,0-2.25,8.49,5.77,5.77,0,0,0,0,.93.76.76,0,0,1,0,.16C150,155,148.57,161,145.51,161.11Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.31,138.93c.18,3.46,1.38,13.23,9.16,14.21a8.07,8.07,0,0,0,1.45.06s0-.11,0-.15a5.8,5.8,0,0,1,0-.93,36.12,36.12,0,0,1,2.23-8.5S142.37,139.82,139.31,138.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.11,124.22c-.93,5.21,3.49,19.42,7.46,22.22,5.76,4.07,14.3,3.49,17.54-3.23,3.13-6.51-3-24.92-7.31-27.38C146.39,112.21,136.47,116.51,135.11,124.22Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.62,131.56s-.06.07,0,.11c.32,1,.53,2.09-.24,2.67,0,0,0,.06,0,0C151.38,133.92,151.08,132.41,150.62,131.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.46,130.82c-1.58.35-.75,3.48.71,3.15S150.78,130.52,149.46,130.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.17,130.24s.09,0,.1.06c.22,1,.64,2.06,1.6,2.15,0,0,0,.06,0,.06C156.77,132.64,156.23,131.2,156.17,130.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.77,129c1.53-.53,2.47,2.56,1.06,3.05S155.49,129.44,156.77,129Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.1,130.72a11.84,11.84,0,0,0,1.1-.75c.42-.29.78-.48,1-1a.69.69,0,0,0-.31-.77,1.7,1.7,0,0,0-1.7.27A2.53,2.53,0,0,0,147,129.9.74.74,0,0,0,148.1,130.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157,126.19c-.45,0-.88,0-1.33,0a2.17,2.17,0,0,1-1.35-.26.68.68,0,0,1-.18-.81,1.69,1.69,0,0,1,1.55-.74,2.47,2.47,0,0,1,1.72.53A.73.73,0,0,1,157,126.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.82,141.4a1.58,1.58,0,0,0,1,.35,2.61,2.61,0,0,0,1-.52,0,0,0,0,1,.06,0,1.34,1.34,0,0,1-1.09.85,1.06,1.06,0,0,1-1-.65A.05.05,0,0,1,150.82,141.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.41,139.52a8.67,8.67,0,0,1,3.78-1.24c.11-.05.15-.3.14-.41h0l-.62-2.05c.31.06,1.86.31,1.74-.07a51.36,51.36,0,0,0-4-9.6.09.09,0,0,0-.17.07c.9,3.08,2.33,6,3.28,9.06a5.66,5.66,0,0,0-1.68-.05c-.09.05.77,2.13.82,2.47a4.94,4.94,0,0,0-3.46,1.4C151.94,139.48,151.88,139.91,152.41,139.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.06,140.12c.53-.3.8-2.42-.22-2.31s-3.13,1.15-3.57,2.56c-.38,1.24,2.26-.22,2.78-.16S154.69,140.34,155.06,140.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.05,140.21l.25,0c-.17-.63-1-1.23-2.33-1a2.75,2.75,0,0,0-.7,1.09C150.9,141.6,153.53,140.15,154.05,140.21Z",
    style: {
      fill: "#ff9abb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.61,130.09c-.35,1.67-1,5.57-1.68,6-1.58-5-2.4-9.64-1.62-12.72a10.67,10.67,0,0,1,1.62-3.54C137.28,121.15,139,128.33,138.61,130.09Z",
    style: {
      fill: "#263238",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151,120.4a5.15,5.15,0,0,1-3.82,3.25,5.27,5.27,0,0,1-4.88-1.56s-.09,0-.06,0a5.19,5.19,0,0,0,5,1.92,5.28,5.28,0,0,0,3.87-3.61C151.18,120.37,151.07,120.33,151,120.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.69,110.27a8.14,8.14,0,0,0-5.13,5.86,5.82,5.82,0,0,0,.76,3.73s.12,0,.1,0a6.33,6.33,0,0,1,.86-6.41,8.17,8.17,0,0,1,6.5-3.29,5.19,5.19,0,0,1,3.37,1.15c.09.08.28-.06.19-.15C147,109.64,144.21,109.3,141.69,110.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.19,110.44a6.55,6.55,0,0,0-3.84-2.37c-2.11-.44-4,.42-5.86,1.32-.05,0,0,.1,0,.08a9,9,0,0,1,5-1.21,6.48,6.48,0,0,1,3.89,1.94,6.29,6.29,0,0,1,.21,8.25,6.44,6.44,0,0,1-4.57,2.21c-.07,0-.08.11,0,.11a6.44,6.44,0,0,0,5.11-10.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.13,128.15s-4.47-4.07-3.28-7.78c.68-2.1,5-3.38,5-3.38a8.06,8.06,0,0,1,3.67-4.94c3.23-2.06,8.14-1.5,8.14-1.5s2.65-3.1,6.41-2.44c5.24.93,7.07,7.76,3.45,11.46-2.54,2.6-7.69,1.37-7.69,1.37-.39.2-3.61,4.15-8,1.6,0,0-1.72,3.15-4.55,2.39A3.89,3.89,0,0,1,135.13,128.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.65,135.68s-3.94-4.22-5.9-2.75,1.47,7.91,4.09,8.49a2.57,2.57,0,0,0,3.21-1.85Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.78,134.75s0,.06,0,.07a6.47,6.47,0,0,1,3.89,3.54,1.42,1.42,0,0,0-2.15-.08s0,.1.06.09a1.57,1.57,0,0,1,1.8.3,7.88,7.88,0,0,1,1,1.27c.1.15.37,0,.29-.15l0,0C139.38,137.51,137.21,134.64,134.78,134.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.51,249.52a4.37,4.37,0,0,1-4.13,2.79,6.45,6.45,0,0,1-.53,4.37c-1.31,2.32-5.53,1.28-5.53,1.28a7.93,7.93,0,0,1-1.29,4.52c-1.48,2.09-5.88,1.65-5.88,1.65a7,7,0,0,1-3.64,3.25c-4.25,1.47-9.59-2.84-13-5.54s-10.6-13.59-12.17-15.52l17.17-22.13s18.81,7.77,22.38,11.52C196.88,238.87,201.61,246.3,200.51,249.52Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.5,251.84c-2.39-4.13-5.87-7.33-9.17-10.72-.07-.07-.19,0-.12.12,3.32,3.33,5.93,7.28,9.11,10.73A.11.11,0,0,0,196.5,251.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.48,257.61a12.5,12.5,0,0,0-2.23-2.37c-.84-.79-1.7-1.56-2.57-2.31-1.74-1.52-3.52-3-5.34-4.42-.08-.06-.19.05-.11.12,1.73,1.51,3.44,3.05,5.11,4.64.83.79,1.66,1.59,2.48,2.4a15.09,15.09,0,0,0,2.43,2.16A.17.17,0,0,0,190.48,257.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.08,264.06a8.71,8.71,0,0,0-2.12-2c-.81-.67-1.61-1.35-2.41-2-1.6-1.36-3.2-2.73-4.76-4.15a.08.08,0,0,0-.11.12c1.57,1.45,3.12,2.92,4.7,4.36l2.34,2.1a8.11,8.11,0,0,0,2.29,1.72C183.06,264.16,183.1,264.1,183.08,264.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.32,246.32c-8.65-9.71-27.46-27.78-27.33-34.3.14-7.69-1.37-32.36.55-47.85,1.08-8.74,8.13-11.12,10.32-2.15,2.29,9.32,9.56,39,10.1,41,.7,2.57,20.44,19.06,25.74,22.07C177.55,227.31,156.06,248.27,154.32,246.32Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,246.55l20.67-23.12s-21.68-16-23.32-20-8.32-31.22-10.52-40.23c-2.43-10-9.94-11.42-11.73,0-2.15,13.64-1.27,43.94-1.11,49S152,246.55,152,246.55Z",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.36,224.77a2.6,2.6,0,0,1-.1-.25v0c0,.22,0,.45,0,.67a1.12,1.12,0,0,1-.07.59,1.13,1.13,0,0,1-.31.43,1.43,1.43,0,0,1-.22.15,1,1,0,0,1-.25.07.48.48,0,0,0-.17.05l-.17.06-.15.08-.13.09a.85.85,0,0,0-.17.16.44.44,0,0,0-.09.11.71.71,0,0,0-.1.14.46.46,0,0,0-.07.16.64.64,0,0,0-.06.18,2.36,2.36,0,0,0,.29,1.37c0-.23,0-.45,0-.68a1.16,1.16,0,0,1,.09-.57,1.07,1.07,0,0,1,.16-.25,1,1,0,0,1,.31-.26l.16-.07a.61.61,0,0,1,.18,0,1.43,1.43,0,0,0,.71-.37,1.11,1.11,0,0,0,.32-.5,1.05,1.05,0,0,0,.05-.19A2.07,2.07,0,0,0,150.36,224.77Zm12.43,4a1,1,0,0,1-.58-.09,1.07,1.07,0,0,1-.63-.81,1.32,1.32,0,0,0-.54-.85,1.37,1.37,0,0,0-.52-.22,2,2,0,0,0-1.1.2l-.27.1h0c.22,0,.44,0,.66,0a1.57,1.57,0,0,1,.38,0h0l.19.05h0l.07,0a.51.51,0,0,1,.16.09.8.8,0,0,1,.17.15.64.64,0,0,1,.1.13.16.16,0,0,1,0,.07.35.35,0,0,1,.06.14.08.08,0,0,1,0,.05l0,.11a1.35,1.35,0,0,0,1,1.1,2.4,2.4,0,0,0,1.38-.28C163.24,228.8,163,228.82,162.79,228.81ZM142,217.59a1,1,0,0,1-.47.34,1.06,1.06,0,0,1-1-.13,1.34,1.34,0,0,0-1.51,0,2.61,2.61,0,0,0-.75,1.18c.18-.15.33-.31.49-.47a1.22,1.22,0,0,1,.46-.37,1.06,1.06,0,0,1,1,.1,1.34,1.34,0,0,0,1.5,0,2.31,2.31,0,0,0,.77-1.17C142.36,217.26,142.21,217.43,142,217.59Zm21.31-1.26c-.15.13-.29.28-.45.43a1,1,0,0,1-.47.34,1.06,1.06,0,0,1-1-.13,1.32,1.32,0,0,0-1.17-.16,1.06,1.06,0,0,0-.34.16,2.61,2.61,0,0,0-.75,1.18l0,0,.45-.44a1.22,1.22,0,0,1,.46-.37.7.7,0,0,1,.19-.06,1.06,1.06,0,0,1,.83.16,1.34,1.34,0,0,0,1.5.05,2.13,2.13,0,0,0,.74-1.12l0-.05ZM146.6,199.09a1.1,1.1,0,0,1-1.49.21,1.34,1.34,0,0,0-1.51,0,2.72,2.72,0,0,0-.76,1.19c.18-.15.33-.31.49-.47a1.32,1.32,0,0,1,.47-.37,1,1,0,0,1,1,.1,1.36,1.36,0,0,0,1.51,0,2.45,2.45,0,0,0,.77-1.17A5.44,5.44,0,0,0,146.6,199.09Zm-17.82-18.27a1,1,0,0,1-.47.35,1.06,1.06,0,0,1-1-.13,1.33,1.33,0,0,0-1.49,0c0,.15,0,.31,0,.47a1.18,1.18,0,0,1,.19-.11,1.06,1.06,0,0,1,1,.09,1.33,1.33,0,0,0,1.5.06,2.5,2.5,0,0,0,.78-1.17C129.09,180.5,128.94,180.67,128.78,180.82Zm1.52,12.06c0,.22,0,.45,0,.67a1.12,1.12,0,0,1-.07.59,1,1,0,0,1-.78.65,1.37,1.37,0,0,0-1.11,1,2.36,2.36,0,0,0,.29,1.37c0-.23,0-.45,0-.68a1.16,1.16,0,0,1,.09-.57,1.06,1.06,0,0,1,.81-.63,1.36,1.36,0,0,0,1.08-1.06A2.64,2.64,0,0,0,130.3,192.88Zm25,45.65-.19.19a1.19,1.19,0,0,1-.47.36,1,1,0,0,1-1-.09,1.38,1.38,0,0,0-1.51-.06,2.45,2.45,0,0,0-.77,1.18c.18-.15.33-.31.49-.47a1.18,1.18,0,0,1,.47-.35,1.06,1.06,0,0,1,1,.13,1.32,1.32,0,0,0,1.51,0,1.56,1.56,0,0,0,.5-.63A2.51,2.51,0,0,0,155.34,238.53Zm-13.21-49.76a1.08,1.08,0,0,1-.58-.09,1,1,0,0,1-.63-.81,1.34,1.34,0,0,0-1.06-1.08,2.64,2.64,0,0,0-1.37.31c.23,0,.45,0,.68,0a1.34,1.34,0,0,1,.58.07,1,1,0,0,1,.65.78,1.37,1.37,0,0,0,1,1.11,2.41,2.41,0,0,0,1.38-.29C142.58,188.76,142.35,188.77,142.13,188.77Zm-7.86,19.7a1.11,1.11,0,0,1-.58-.08,1.05,1.05,0,0,1-.62-.82A1.36,1.36,0,0,0,132,206.5a2.66,2.66,0,0,0-1.37.3c.23,0,.45,0,.68,0a1.14,1.14,0,0,1,.59.07,1.07,1.07,0,0,1,.65.78,1.33,1.33,0,0,0,1,1.1,2.33,2.33,0,0,0,1.38-.28C134.72,208.47,134.5,208.48,134.27,208.47Zm17.34,4.12a1,1,0,0,1-.58-.09,1.07,1.07,0,0,1-.63-.81,1.32,1.32,0,0,0-1.06-1.07,2.64,2.64,0,0,0-1.37.3c.23,0,.45,0,.68,0a1.2,1.2,0,0,1,.58.06,1.07,1.07,0,0,1,.66.79,1.35,1.35,0,0,0,1,1.1,2.4,2.4,0,0,0,1.38-.28C152.06,212.58,151.84,212.6,151.61,212.59Zm-11.84,18.54a1,1,0,0,1-.58-.09,1.07,1.07,0,0,1-.63-.81,1.32,1.32,0,0,0-1.06-1.07l-.21,0c.61.77,1.24,1.54,1.86,2.3h0a2.58,2.58,0,0,0,1.29-.29C140.22,231.12,140,231.14,139.77,231.13Zm-6.52-59.9a1.1,1.1,0,0,1-.58-.08,1.08,1.08,0,0,1-.63-.82,1.33,1.33,0,0,0-1.06-1.07,2.64,2.64,0,0,0-1.37.3c.23,0,.45,0,.68,0a1.14,1.14,0,0,1,.59.07,1,1,0,0,1,.65.78,1.35,1.35,0,0,0,1,1.1,2.33,2.33,0,0,0,1.38-.28C133.7,171.23,133.48,171.24,133.25,171.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.33,221.74c-3.19,2.81-6.19,5.88-9.09,9-1.43,1.53-2.84,3.08-4.21,4.66s-2.73,3.38-4.12,5.06c-.06.08,0,.19.11.11,1.48-1.59,3-3.09,4.54-4.67s2.85-3.06,4.28-4.59c2.9-3.12,5.83-6.23,8.6-9.46A.07.07,0,1,0,167.33,221.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135,226.37c-1.7-2.58-3.43-5.13-5.11-7.72a25.46,25.46,0,0,1-2.22-3.9,14.69,14.69,0,0,1-1.1-4.38c-.33-3.1-.23-6.27-.26-9.38,0-3.26,0-12-.06-15.24,0-3.63-.05-7.25-.1-10.88a.07.07,0,0,0-.13,0c-.19,2.42-.33,4.85-.45,7.28-.15-1.2-.28-2.4-.41-3.6,0-.07-.12-.07-.12,0a31.52,31.52,0,0,0,.29,3.63c.06.35.13.7.19,1.05-.16,3.85-.25,13.18-.24,17,0,3.21-.1,6.47.2,9.67a17,17,0,0,0,.93,4.4,20.74,20.74,0,0,0,2.07,3.89,73.74,73.74,0,0,0,6.35,8.27C134.92,226.59,135.07,226.47,135,226.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.33,211.26c-1-.81-1.84-1.76-2.75-2.63s-1.86-1.73-2.8-2.59a7.83,7.83,0,0,1-2.28-2.86,26.48,26.48,0,0,1-.83-3.41c-.92-4.08-4.26-17.28-5.38-21.31,0,0,0,0,0,0-.18-2.07-.39-4.13-.71-6.19,0-.09-.16-.09-.15,0,.13,1.78.35,3.54.59,5.31-.15-.54-.3-1.08-.46-1.62-.81-2.79-1.76-5.52-2.65-8.28a0,0,0,0,0-.09,0c1.29,5.06,3.67,15.2,5,20.26.66,2.52,2.31,9.18,2.93,11.72a36.22,36.22,0,0,0,.91,3.55,5.64,5.64,0,0,0,1.83,2.53l3.2,2.74c1.16,1,2.42,1.86,3.52,2.89C157.3,211.44,157.41,211.32,157.33,211.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.34 213.26 384.28 62.34 384.28 258.98 225.65 243.73 212.34 213.26",
    style: {
      fill: "#3DD064",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "215.42 220.31 384.28 62.34 384.28 258.98 222.71 237 215.42 220.31",
    style: {
      fill: "#3DD064",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.93,151.53l-3.29,8.16-10.12-10.34-2.88,3.31s9.9,16.42,10,15.68l3.37-7,4.85,4.9-.38-12.29Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,160.12c-.13-2-.21-4.07-.43-6.08,0-.08-.12-.11-.14,0-.41,1.95.13,9.7.12,11.55l0,0c-.2-.21-4.49-4.31-4.54-4.24-.73,1.11-3.2,6.23-3.37,6.7-1.57-2.61-7.57-12.09-9.42-14.55a.07.07,0,1,0-.12.07c1.38,2.75,9.32,15.51,9.44,15.48a78.58,78.58,0,0,0,3.53-7.43c.72.89,5.06,5.51,5.07,5.21A64.55,64.55,0,0,0,152,160.12Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bricks--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M414.79,350.52c4.52.7,9,1.36,13.39,2.08l6.61,1c2.19.34,4.37.74,6.56,1.1l-.52.44L440.77,344l.42.5L428,342.1c-4.42-.79-8.81-1.67-13.21-2.5l.31-.27c0,1.84-.08,3.68-.12,5.55Zm0,0-.14-5.54c0-1.87-.11-3.75-.13-5.65V339l.32.06c4.42.72,8.85,1.4,13.27,2.17l13.25,2.27.41.07V344l0,11.19v.54l-.52-.1c-2.23-.41-4.47-.79-6.68-1.23l-6.64-1.28C423.46,352.28,419.1,351.39,414.79,350.52Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.56,367.24c4.52.69,9,1.36,13.4,2.07l6.6,1.05c2.2.35,4.37.74,6.56,1.11l-.52.44-.05-11.19.41.49-13.23-2.4c-4.41-.78-8.81-1.66-13.21-2.49l.32-.27c0,1.83-.09,3.68-.13,5.54Zm0,0-.14-5.54c0-1.87-.11-3.76-.13-5.65v-.32l.32,0c4.42.73,8.86,1.4,13.27,2.17l13.25,2.28.42.07v.42l-.05,11.19v.53l-.52-.09c-2.23-.41-4.46-.8-6.68-1.23l-6.64-1.28C438.23,369,433.87,368.1,429.56,367.24Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400,362c4.52.69,9,1.36,13.39,2.07l6.61,1.06c2.19.34,4.37.73,6.56,1.1l-.52.44L426,355.51l.41.49-13.22-2.4c-4.42-.78-8.81-1.66-13.22-2.49l.32-.27c0,1.83-.08,3.68-.13,5.54Zm0,0-.14-5.54c0-1.87-.11-3.75-.13-5.65v-.32l.32.05c4.42.73,8.85,1.4,13.27,2.17L426.59,355l.41.07v.42L427,366.7v.53l-.53-.09c-2.22-.41-4.46-.8-6.67-1.23l-6.64-1.28C408.69,363.78,404.33,362.89,400,362Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.73,60.77l13.35-.28,6.58-.12c2.19,0,4.37,0,6.55,0l-.45.45-.05-11.19.5.49L72,50c-4.42,0-8.83-.11-13.24-.16l.27-.27c0,1.83-.09,3.67-.13,5.53Zm0,0-.15-5.54c0-1.87-.11-3.76-.13-5.65v-.27h.28c4.41,0,8.82-.16,13.24-.16l13.24-.06h.5v.51l-.06,11.19v.44h-.44c-2.23,0-4.47,0-6.7-.05L71.85,61Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,74.88l13.35-.28,6.58-.12c2.19,0,4.36,0,6.55,0l-.45.45,0-11.19.5.49L57.2,64.12C52.78,64.12,48.37,64,44,64l.27-.27c0,1.83-.09,3.67-.13,5.53Zm0,0-.15-5.54c0-1.87-.11-3.76-.13-5.65v-.27H44c4.41,0,8.82-.16,13.24-.16l13.24-.06h.5v.51l-.06,11.19v.44h-.44c-2.24,0-4.47,0-6.7,0l-6.66-.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.56,65.3c4.52.69,9,1.36,13.4,2.07l6.6,1c2.2.34,4.37.74,6.56,1.11l-.52.44-.05-11.19.41.49-13.23-2.4c-4.41-.78-8.81-1.67-13.21-2.5l.32-.26c0,1.83-.09,3.68-.13,5.54Zm0,0-.14-5.55c0-1.86-.11-3.75-.13-5.64v-.32l.32.05c4.42.73,8.86,1.4,13.27,2.17l13.25,2.27.42.07v.43L456.49,70v.53l-.52-.1c-2.23-.41-4.46-.79-6.68-1.23l-6.64-1.28C438.23,67.05,433.87,66.16,429.56,65.3Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.08,200.81c-4.52-.69-9-1.36-13.39-2.07l-6.6-1.05c-2.2-.34-4.38-.74-6.57-1.11l.53-.44.05,11.19-.41-.49,13.23,2.4c4.41.78,8.8,1.67,13.21,2.5l-.32.26c0-1.83.08-3.68.13-5.54Zm0,0,.14,5.55c0,1.86.11,3.75.13,5.64v.32l-.32,0c-4.42-.73-8.85-1.4-13.27-2.17l-13.25-2.27-.41-.08v-.42l0-11.19v-.53l.52.09c2.22.41,4.46.8,6.67,1.24l6.64,1.28C384.41,199.06,388.77,200,393.08,200.81Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.5,102.45c-4.52-.7-9-1.36-13.39-2.08l-6.6-1.05c-2.2-.34-4.38-.74-6.57-1.1l.53-.44,0,11.19-.41-.5,13.23,2.4c4.41.79,8.8,1.67,13.21,2.5l-.32.27c0-1.84.09-3.68.13-5.55Zm0,0,.14,5.54c.05,1.87.11,3.75.13,5.65V114l-.33-.06c-4.42-.72-8.85-1.4-13.26-2.17l-13.26-2.27-.41-.07V109l.05-11.19v-.54l.52.1c2.22.41,4.46.79,6.68,1.23l6.63,1.28C417.83,100.69,422.19,101.58,426.5,102.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.45,219.73l-13.36.27-6.57.12c-2.19,0-4.37,0-6.55,0l.45-.44.05,11.18-.5-.49,13.24.06c4.41,0,8.83.11,13.24.16l-.27.27c0-1.83.08-3.67.13-5.53Zm0,0,.14,5.53c.05,1.87.11,3.76.13,5.65v.27h-.28c-4.41.05-8.83.16-13.24.16l-13.24.06h-.5v-.51l.05-11.18v-.45H248c2.23,0,4.47,0,6.69.05l6.67.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.31,184.1c-4.52-.69-9-1.36-13.39-2.07L358.31,181c-2.19-.34-4.37-.73-6.56-1.1l.52-.44.06,11.19-.42-.49,13.23,2.39c4.42.79,8.81,1.67,13.22,2.5l-.32.27c0-1.84.08-3.68.13-5.54Zm0,0,.14,5.54c0,1.87.11,3.75.13,5.65v.32l-.32-.05c-4.42-.73-8.85-1.4-13.27-2.18l-13.25-2.27-.41-.07v-.42l.05-11.19v-.54l.53.1c2.22.41,4.46.8,6.67,1.23l6.64,1.28C369.64,182.35,374,183.24,378.31,184.1Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pipeline--inject-18"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 111.69,
    y: 44.11,
    width: 219.27,
    height: 9.58,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "464.95 81.82 464.95 91.4 339.39 53.69 339.39 44.11 464.95 81.82",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.1,80.93,379.6,65.77a33.23,33.23,0,0,1,10.77-6.35l30.33,9.11A65.1,65.1,0,0,1,430.1,80.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.8,
    y: 42.34,
    width: 24.36,
    height: 13.36,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.03,
    y: 42.34,
    width: 24.36,
    height: 13.36,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.53 61.7 339.39 55.7 339.39 42.34 359.53 48.34 359.53 61.7",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.3,
    y: 16.38,
    width: 42.34,
    height: 9.58,
    transform: "translate(95.3 137.65) rotate(-90)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.3,
    y: 36.84,
    width: 24.36,
    height: 13.36,
    transform: "translate(72.95 160) rotate(-90)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.21,
    y: 16.38,
    width: 42.34,
    height: 9.58,
    transform: "translate(318.21 360.55) rotate(-90)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.2,
    y: 36.84,
    width: 24.36,
    height: 13.36,
    transform: "translate(295.86 382.9) rotate(-90)",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bat--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M398,111.26l-9.41-14a9.19,9.19,0,0,0-4.75,1.5,10.11,10.11,0,0,0-2.51,2.25,10.63,10.63,0,0,0-1,1.4c-5.57,9.61,4.45,26.06,7.42,29.39h0c.34.38.59.59.71.59h0C389.65,132.29,398,111.26,398,111.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.57,107.59l-1-1.54h0l0-.09-.11-.17,0,0-.47-.69-5.24-7.78c-18,6.24-.77,30.67-.77,30.67Z",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.57,107.59l-1-1.54h0l0-.09-.11-.17,0,0-.47-.69-5.24-7.78c-18,6.24-.77,30.67-.77,30.67Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M392.41,108.13a9.94,9.94,0,0,0,1.93-2.38l-.47-.69a11.45,11.45,0,0,1-2,2.48,3.55,3.55,0,0,1-2.08,1,3.26,3.26,0,0,1-2.2-.68A7,7,0,0,1,386,106a13,13,0,0,1-1.15-2.3,8.48,8.48,0,0,0,2.45,4.59,3.74,3.74,0,0,0,2.58,1A4.05,4.05,0,0,0,392.41,108.13Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M394.54,106.05h0l0-.09-.11-.17c-.18.34-.35.69-.54,1-.38.75-.78,1.49-1.23,2.2a14.11,14.11,0,0,1-3.07,3.79,3.72,3.72,0,0,1-2.11.83,3.33,3.33,0,0,1-2.13-.74,9.92,9.92,0,0,1-2.72-4.1,8.54,8.54,0,0,0,2.37,4.51,3.71,3.71,0,0,0,2.49,1,4.15,4.15,0,0,0,2.57-.91,12,12,0,0,0,3.18-4.09q.42-.84.78-1.71c-.07.22-.14.45-.22.67-.31,1-.62,1.93-1,2.89a34.71,34.71,0,0,1-2.44,5.49,7.06,7.06,0,0,1-1.83,2.2,2.64,2.64,0,0,1-2.56.14,5.23,5.23,0,0,1-2.14-1.91,12.42,12.42,0,0,1-1.4-2.68,10.43,10.43,0,0,0,1.07,2.88,5.8,5.8,0,0,0,2.2,2.28,3.71,3.71,0,0,0,1.61.39,2.88,2.88,0,0,0,.86-.1,3.12,3.12,0,0,0,.78-.37,7.53,7.53,0,0,0,2.1-2.42,25.94,25.94,0,0,0,2.33-5.72A40.71,40.71,0,0,0,394.54,106.05Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M423.88,102.3a9.72,9.72,0,0,0-7-4.18l-2.08,2.72-2.5,3.28-5.65,7.4s7.13,21.49,8.22,21.69c.29,0,1.61-1.33,3.25-3.6a0,0,0,0,1,0,0c.64-.87,1.33-1.89,2-3C424.34,119.77,428.81,109.17,423.88,102.3Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.31,108l1.12-1.47,0,0,.06-.08.12-.17,0,0,.51-.66,5.69-7.46c17.6,7.31-1.06,30.66-1.06,30.66Z",
    style: {
      fill: "#3DD064"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.31,108l1.12-1.47,0,0,.06-.08.12-.17,0,0,.51-.66,5.69-7.46c17.6,7.31-1.06,30.66-1.06,30.66Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.44,108.73a9.83,9.83,0,0,1-1.79-2.49l.51-.66a11.47,11.47,0,0,0,1.82,2.59,3.56,3.56,0,0,0,2,1.11,3.23,3.23,0,0,0,2.24-.54A7.18,7.18,0,0,0,419,107a12.54,12.54,0,0,0,1.28-2.23,8.47,8.47,0,0,1-2.72,4.44,3.69,3.69,0,0,1-2.63.8A3.94,3.94,0,0,1,412.44,108.73Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.43,106.53l0,0,.06-.08.12-.17c.15.36.31.72.47,1.07.34.77.7,1.53,1.1,2.26a14,14,0,0,0,2.84,4,3.63,3.63,0,0,0,2,1,3.28,3.28,0,0,0,2.18-.61,9.83,9.83,0,0,0,3-3.93,8.65,8.65,0,0,1-2.64,4.37,3.71,3.71,0,0,1-2.55.88,4.13,4.13,0,0,1-2.5-1.06,11.79,11.79,0,0,1-2.93-4.28c-.25-.58-.47-1.16-.68-1.75.06.22.11.46.18.68.24,1,.5,2,.79,2.94a34.85,34.85,0,0,0,2.11,5.63,6.81,6.81,0,0,0,1.69,2.3,2.65,2.65,0,0,0,2.55.3,5.26,5.26,0,0,0,2.25-1.79,12,12,0,0,0,1.56-2.58,10.52,10.52,0,0,1-1.24,2.81,5.77,5.77,0,0,1-2.34,2.14,3.46,3.46,0,0,1-1.63.29,2.63,2.63,0,0,1-.85-.15,3,3,0,0,1-.76-.42,7.46,7.46,0,0,1-1.94-2.53,26.41,26.41,0,0,1-2-5.85A41.16,41.16,0,0,1,410.43,106.53Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.86,65.4a5,5,0,0,1-1.71-2.17c-.19-.47.54-.79.73-.32a4.14,4.14,0,0,0,1.46,1.85A.4.4,0,0,1,397.86,65.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.25,64.83a5,5,0,0,1,2.24-1.62c.48-.17.77.57.28.74a4.17,4.17,0,0,0-1.9,1.38A.4.4,0,0,1,398.25,64.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.94,64.69a5,5,0,0,1,.37-2.74.4.4,0,0,1,.74.31,4.15,4.15,0,0,0-.32,2.33A.4.4,0,0,1,397.94,64.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.64,69.16a5,5,0,0,1-1-2.59.4.4,0,0,1,.79-.08,4.2,4.2,0,0,0,.84,2.2A.4.4,0,0,1,409.64,69.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.18,68.73a5,5,0,0,1,2.62-.87.4.4,0,0,1,.05.79,4.27,4.27,0,0,0-2.23.74C410.2,69.68,409.76,69,410.18,68.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.93,68.51a4.89,4.89,0,0,1,1.18-2.5c.33-.39.94.13.6.51a4.17,4.17,0,0,0-1,2.13A.4.4,0,0,1,409.93,68.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.74,68.53c-2-.74-3,1.39-4.17,1.62-.69.14-4.77-1.33-5.55-1.86-1.13-.77-1.29-3-2.83-3.09-3.61-.11-5.15,21.61-5.15,21.61h0l-.28.1c-4.19,1.35-6.29,3.76-7.18,6.36a9.49,9.49,0,0,0-.42,1.73h0c-.51,3.28.7,6.87,3.89,12.07,4,6.52,8.35,8.16,12.76,8.29a15.2,15.2,0,0,0,3.29-.24h0a12.53,12.53,0,0,0,4.55-1.82h0a19.63,19.63,0,0,0,5.35-5.44c2.57-3.69,4-6.55,4.48-9.12a9.56,9.56,0,0,0-.2-4.46,8.23,8.23,0,0,0-4.73-5.82c-.39-.16-1.63-.45-1.63-.45C412.86,86.46,414,69.72,410.74,68.53Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395,94s-.05-2.32.22-2.43,1.49,1.73,1.49,1.73S395.28,93.9,395,94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.41,94.41s.18-2.31-.07-2.44-1.6,1.64-1.6,1.64S407.14,94.25,407.41,94.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.47,94.44a16.57,16.57,0,0,1,3.36-1.12A13.56,13.56,0,0,1,401.3,93a12.86,12.86,0,0,1,3.42.55A21.47,21.47,0,0,1,408,94.85a17.24,17.24,0,0,0-1.47-1.07,10.91,10.91,0,0,0-1.64-.82,10.63,10.63,0,0,0-3.61-.75,10.48,10.48,0,0,0-3.65.51A9.53,9.53,0,0,0,394.47,94.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.46,97.07a2,2,0,1,0-2.1,1.92A2,2,0,0,0,394.46,97.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.4,97.88a2,2,0,1,0-2.11,1.92A2,2,0,0,0,412.4,97.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.11,93.68c-1.16-2.32-3.87.53-3.87.53s-2.45-3.09-3.81-.88,2.64,6.52,3.54,6.56S406.19,95.85,405.11,93.68Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400,97.32c-.6.1-2.31-2.69-1.16-3.37C400.23,93.13,400.53,97.23,400,97.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.23,97.42c.59.15,2.54-2.47,1.46-3.25C402.38,93.23,401.71,97.28,402.23,97.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.82,86.51c-.52.09.35-6,.15-6.46s.25-2.81-.11-6.57c0-.42,2.29-6.67,3.62-8,.32-.32,11.57,4.53,16.08,13.27a13.08,13.08,0,0,0,0,5.54,8.33,8.33,0,0,1-.4,3.6S407.69,84.07,393.82,86.51Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.68,85a7,7,0,0,1-.12,1.18c0,.2-.07.41-.11.6-.08.4-.18.76-.26,1.07,0,0-5.5-3.82-19.37-1.39-.5.09.26-5.41.17-6.35a.56.56,0,0,0,0-.1,5.61,5.61,0,0,1,0-1.37c0-.78.09-1.86,0-3.21l8.41-7.73c3.5,2.08,8.05,5.56,10.73,10.21.16.27.3.53.44.8a21.44,21.44,0,0,0-.3,3.62,8.06,8.06,0,0,0,.33,1.92A2.8,2.8,0,0,1,413.68,85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.17,88c.54.12,1.08-6,1.31-6.4s-1.4-2.65-.81-6.22c.07-.41-1.49-6-3-7.12-.37-.26-12.74,3.63-17.13,8.86-.14.17.06,4.5-.93,7.1-.34.89.15,1.71.36,2.66C392.93,86.85,399,84.78,413.17,88Z",
    style: {
      fill: "#37474f"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlashlightCuate);
export default __webpack_public_path__ + "static/media/Flashlight-cuate.5c6eafd4920498613018ae96ed1f165d.svg";
export { ForwardRef as ReactComponent };